import React, { useState, useEffect } from 'react';
import { getKinds } from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const Kinds = () => {
  const { t } = useTranslation('global');

  const [kinds, setKinds] = useState([]);
  const [loading, setLoading] = useState(true);
  

  const fetchKinds = async() =>{
    const response = await getKinds();
    console.log(response);
    setKinds(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchKinds();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' },
    { Header: t("list.days"), accessor: 'days' },
    { Header: t("list.entry_no"), accessor: 'entry_no' },
    { Header: t("list.daily"), accessor: 'daily' },
    { Header: t("list.from"), accessor: 'from' },
    { Header: t("list.to"), accessor: 'to' },
    { Header: t("list.selectedDays"), accessor: 'allowed_days'}

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth maxWidth="xl">
      <DataTable initialData={kinds} columns={columns} entityName="kinds" h2={t("list.kinds")} />
    </Container>
  );
};

export default Kinds;
